"use client";
/*
 * Documentation:
 * DC_Excursion_Card — https://app.subframe.com/4f62853ee923/library?component=DC_Excursion_Card_8835d124-dfd7-43c0-9345-c5fbfc0ae44a
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Dc_Excursion_CardRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  subtitle?: React.ReactNode;
  heading?: React.ReactNode;
  variant?: "default";
  isMarginal?: boolean;
  iconSlot?: React.ReactNode;
  className?: string;
}

const Dc_Excursion_CardRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Excursion_CardRootProps
>(function Dc_Excursion_CardRoot(
  {
    subtitle,
    heading,
    variant = "default",
    isMarginal = false,
    iconSlot,
    className,
    ...otherProps
  }: Dc_Excursion_CardRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "group/8835d124 flex h-full w-full cursor-pointer flex-col items-start gap-32 rounded-md bg-neutral-50 px-6 py-6 comp-excursion-card hover:bg-neutral-100",
        { "h-auto w-full flex-row flex-nowrap gap-6 px-6 py-6": isMarginal },
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div
        className={SubframeUtils.twClassNames(
          "flex w-full flex-col items-end",
          { "h-auto w-auto flex-none order-last": isMarginal }
        )}
      >
        {iconSlot ? (
          <div className="flex flex-col items-end">{iconSlot}</div>
        ) : null}
      </div>
      <div
        className={SubframeUtils.twClassNames(
          "flex flex-col items-start gap-2",
          {
            "h-auto grow shrink-0 basis-0 flex-col flex-nowrap gap-2":
              isMarginal,
          }
        )}
      >
        {subtitle ? (
          <span className="w-full text-caption font-caption text-subtext-color comp-excursion-card-title">
            {subtitle}
          </span>
        ) : null}
        {heading ? (
          <span className="text-heading-3 font-heading-3 text-default-font comp-excursion-card-title">
            {heading}
          </span>
        ) : null}
      </div>
    </div>
  );
});

export const Dc_Excursion_Card = Dc_Excursion_CardRoot;
